import React, {useState, useEffect} from 'react';
import Slider from "react-slick";
import {Card, Button, Container, Col, Row} from "react-bootstrap"
import {postApi} from  '../../../api'
import _ from 'lodash'
import { userApi } from "../../../api"; /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
import  '../../Styles/css/w3.css'; /*Comments: Card style, Added By: <Asar>, Create Date: <2020-02-13>*/

export default props => {
    const industries = props.industries
    const [items,setItems] = useState([])
    const [industry,setIndustry] = useState()
    
    const filters = industries.map(item => {
        const variant = item.node.termTaxonomyId===industry ? 'dark' : 'secondary'

        //Commented display all the Cards
        /*if(item.node.name == '5G' || item.node.name == 'MEC' || item.node.name == 'Cloud Gaming')
        {*/
            return (
                /*
                <Button key={item.node.name} onClick={()=>onIndustryChange(item.node.termTaxonomyId)} className="mr-2 mb-2 mw-200" variant={variant}>
                    {_.unescape(item.node.name)}
                </Button>
                */
              
               <Button key={item.node.name} onClick={()=>onIndustryChange(item.node.termTaxonomyId,item.node.name)} className="mr-2 mb-2 mw-200" variant={variant}>
               {_.unescape(item.node.name)}
                </Button>
               )
        //}
       
    })

    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
    async function learnMoreClick(bmo,slug){
        let page="saleskits";
        let bmoname = bmo[0].name;
        let obj={};
        obj['userid']=localStorage['currentuserid'];
        obj['message']= page +'-'+ slug ;
    await userApi.setUserActivitylog(obj); 
    page="products";
    window.location.href = "/"+page+"/"+slug;
    }
    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/

    /*
    const onIndustryChange = industry => {
        setIndustry(industry)
        VerticalFilterClick(industry)
    }
    */

    async function onIndustryChange(industry,name){
        
        let obj={}; 
        obj['userid']=localStorage['currentuserid'];
        obj['message']= 'Verticals' +'_'+ name;
        await userApi.setUserActivitylog(obj); 
        if(name == '5G')
        {  
            
            //window.location.reload(false);
            setIndustry(industry)
           

        }
        else
        {
            setIndustry(industry)
        }
        //setIndustry(industry)
        //VerticalFilterClick(name)
        
    }

    async function VerticalFilterClick(industry)
    {
        let obj={};
        obj['userid']=localStorage['currentuserid'];
        obj['message']= 'Verticals' +'_'+ industry;
        await userApi.setUserActivitylog(obj); 
    }

    useEffect(() => {
        const query = {
            posts_per_page:8,
            env:process.env.REACT_APP_MODE,
            'post-type':'saleskits',
            "orderby":"post_modified"
        }
        if (industry) query.industries = [industry]
        postApi.searchPosts(props.token,1,query).then(res => res.json()).then(json => {
            setItems(json.data)
        })
    }, [industry])


    const itemcards=_.isArray(items)?items:[];
    const cards = itemcards.map(item => {
        const imageURL = _.get(item,'headermedia[0].sizes.post-card-thumbnail') || ""
        //const desc = item.post_excerpt.length > 100 ? item.post_excerpt.substr(0,100)+"..." : item.post_excerpt;  {/*Comments: commented, Modified By: <Asar>, Date Modified: <2020-02-14>*/}
        const desc = item.post_excerpt.length > 155 ? item.post_excerpt.substr(0,154)+" ..." : item.post_excerpt; {/*Comments: Post Content Restriction, Modified By: <Asar>, Date Modified: <2020-02-14>*/}
        const title = item.post_title.length > 48 ? item.post_title.substr(0,47)+" ..." : item.post_title; {/*Comments: Post Content Restriction, Modified By: <Asar>, Date Modified: <2020-02-14>*/}

        {/*Cards Uploaded time display*/}
        const uploadeddate = item.post_date.length > 0 ? new Date(item.post_date) : new Date(item.post_modified);
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const uploadedFormattedDate = monthNames[uploadeddate.getMonth()] + "-" + uploadeddate.getFullYear();
        const uploadedSalesKitsDate = uploadeddate.getDate() + "-" + monthNames[uploadeddate.getMonth()] + "-" + uploadeddate.getFullYear();
        {/*Cards Uploaded time display*/}
        
        const industrymap =
            item.industry.map( ind => {
                return (
                   ind.name
                )
            })
    
        
        //const industrylist = industrymap.length > 1 ? industrymap[0].substr(0,15) +"..." : industrymap;   /*Comments: Post Content Restriction, Modified By: <Asar>, Date Modified: <2020-02-14>*/
        //const industrylist = industrymap.length > 1 ? industrymap[0].substr(0,39) +" ..." :industrymap.length == 1 ? industrymap[0].substr(0,39) +"..." : industrymap;   /*Comments: Post Content Restriction, Modified By: <Asar>, Date Modified: <2020-02-18>*/
        const industrylist = industrymap.length > 1 ? industrymap[0].substr(0,39) +" ..." :industrymap.length == 1 ? industrymap[0].substr(0,39) +"..." : industrymap; 
        
        
        const headermedia=_.isArray(item.headermedia)?item.headermedia:[item.headermedia];
        const media = _.get(headermedia[0],`sizes.post-card-thumbnail`,"https://via.placeholder.com/450x210")
        const mediaurl = typeof media=== 'object' ? media.url : media
           
        return (
            /*<Card className="post-card w3-card-4 w3-padding-card" key>*/ /*Comments: Commented for Card style-Zoom,spacing, UserActivityLog by CardClick, Added By: <Asar>, Create Date: <2020-02-18>*/
            <Card onClick={()=>learnMoreClick(item.bmos,(item.post_name!==""?item.post_name:item.ID ))} className="post-card mb-4 w3-card-4 Cursor-pointer" key> {/*Comments: Card style-Zoom,spacing, UserActivityLog by CardClick, Added By: <Asar>, Create Date: <2020-02-18>*/}
                <div>  
                    <Card.Img variant="top" src={mediaurl} />
                </div>
                <Card.Body className="w3-container "> {/*Comments: Card style, Added By: <Asar>, Create Date: <2020-02-13>*/}
                   {/*<Card.Title className="w3-textpadding-card">{item.post_title}</Card.Title>*/}
                   <div style={{height:'50px'}}>  
                        <Card.Title className="w3-textpadding-card w3-card-title-fontsize">{title}</Card.Title> {/*Comments: Card style-Zoom,spacing, UserActivityLog by CardClick, Added By: <Asar>, Create Date: <2020-02-18>*/}
                   </div>

                   <div style={{height:'120px'}}> 
                        <Card.Text className="text-muted w3-textpadding-card">{desc}</Card.Text>  {/*Comments: Card style-Zoom,spacing, UserActivityLog by CardClick, Added By: <Asar>, Create Date: <2020-02-18>*/}
                    </div>

                    {/*
                    <div style={{height:'30px'}}> 
                    <Card.Text className="w3-textpadding-card">
                        {
                            item.bmos.map( bmo => {
                                return (
                                    <b key={bmo.name}>{bmo.name} </b>
                                )
                            })
                        }
                        <span className="text-muted"> | </span>


                        {
                            item.industry.map( ind => {
                                return (
                                
                                    <span key={ind.name}>{_.unescape(ind.name )} </span>
                                    
                                )
                            })
                        }
                        
                    </Card.Text>
                    </div>
                    */}

                    {/*Cards Uploaded time display*/}
                    <Card.Text className="w3-textpadding-card">
                        <b>Uploaded On:</b> {uploadedSalesKitsDate} 
                    </Card.Text>
                    {/*Cards Uploaded time display*/}

                    <Card.Text ><br/></Card.Text>
                    {/*<a  href={`/Verticals/${(item.post_name!==""?item.post_name:item.ID )}`} className={"btn btn-primary"}>Learn More </a>*/} {/*Comments: User Activity Log Code Changes, Modified By: <Asar>, Date Modified: <2020-01-21>*/}
                    {/*<a onClick={()=>learnMoreClick(item.bmos,(item.post_name!==""?item.post_name:item.ID ))} className={"btn btn-primary"} style={{cursor:'pointer'}}>Learn More </a>*/} {/*Comments: User Activity Log Changed From Learnmore to Card Click, Modified By: <Asar>, Date Modified: <2020-02-18>*/}
                </Card.Body>
            </Card>
        )
                
    })
    
    const sliderSettings = {
        dots: true,
        gap : 20,
        speed: 500,
        slidesToShow: 4,   
        slidesToScroll: 4  
    }

    
	return(
        <Container className="text-center">
            <br/>
            <h3 className="mb-4">Latest Updates</h3>{/*Comments: 5G text Changes, Added By: <Asar>, Create Date: <2020-02-06>*/ }
            
           {/* {filters}*/}  {/*Remove the buttons under Latest Updates*/}
           {/* <br/><br/>*/}
            {
                cards.length===0 && 
                <div className="no-posts">
                    <h5>No Posts Available</h5>
                </div>
            }
            {
                cards.length > 4 &&
                <Slider className="post-card-slider" {...sliderSettings}>
                    {cards}
                </Slider>
            }
            {
                cards.length <= 4 &&
                <Row className="post-card-slider">
                    { cards.map( card => <Col sm="3">{card}</Col> )}
                </Row>
            }
           

        </Container>
    )
        
}